import * as Cache from '../../cache/Cache'
import Cookies from 'js-cookie';
const user = {
    state: {
      userInfo:{
        userName:'jcq',
        age:1
      },
    },
    mutations: {
      logout (state, vm) {
        Cookies.remove('user');
        Cookies.remove('password');
        Cookies.remove('access');
      },
      setUserInfo(state, userInfo){
        state.userInfo = userInfo;
      }
    }
};

export default user;



// WEBPACK FOOTER //
// ./src/store/modules/user.js